import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var InfoFilled = function (props) { return (React.createElement(Icon, __assign({ width: '20px', height: '20px', viewBox: '0 0 16 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' }, props),
    React.createElement("g", { clipPath: 'url(#clip0_637_19301)' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 16C3.6 16 2.22207e-06 12.4 2.60673e-06 8C2.99139e-06 3.6 3.6 -1.08404e-06 8 -6.99382e-07C12.4 -3.14722e-07 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 5C8.55229 5 9 4.55228 9 4C9 3.44771 8.55229 3 8 3C7.44772 3 7 3.44771 7 4C7 4.55228 7.44772 5 8 5ZM7.98 13C8.37765 13 8.7 12.6362 8.7 12.1875L8.7 7.3125C8.7 6.86377 8.37765 6.5 7.98 6.5C7.58236 6.5 7.26 6.86377 7.26 7.3125L7.26 12.1875C7.26 12.6362 7.58236 13 7.98 13Z', fill: 'currentColor' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: 'clip0_637_19301' },
            React.createElement("rect", { width: '16', height: '16', fill: 'white' }))))); };

export { InfoFilled as default };
//# sourceMappingURL=InfoFilled.js.map
